import script from "./ColorOptionInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorOptionInfo.vue?vue&type=script&setup=true&lang=js"

import "./ColorOptionInfo.vue?vue&type=style&index=0&id=f8e651ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8e651ea"]])

export default __exports__